<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right"></div>
                    <h4 class="page-title">Update Trainee Followup After</h4>
                </div>
            </div>
        </div>

        <div class="row" style="margin-bottom: 162px;">
            <div class="col-md-12">
                <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
                    <span v-for="(err, index) in validation_errors" :key="index">{{ err[0] }} <br/></span>
                </div>
                <b-card>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="form_no">Followup Form No.</label>
                                <input type="number" v-model="followup.form_no" v-validate="'required|max:6|min:4|integer'" id="form_no" name="form_no" class="custom-select custom-select-sm" placeholder="Followup Form number"/>
                                <div class="invalid-feedback">Please enter form number.</div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="form_number">TNA Form No.</label>
                                <input type="number" v-model="trainee.form_no" disabled id="form_number" name="form_number" class="custom-select custom-select-sm" placeholder="Form number"/>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_village_id">Village</label>
                                <select v-model="trainee.c_village_id" disabled id="c_village_id" name="c_village_id" class="custom-select custom-select-sm">
                                    <option selected disabled :value="''">Select a village *</option>
                                    <option v-for="(village, index) in villages" :key="index" :value="village.id">{{ village.id }} : {{ village.desc }}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_mouza_id">Mouza</label>
                                <select v-model="trainee.c_mouza_id" disabled id="c_mouza_id" name="c_mouza_id" class="custom-select custom-select-sm">
                                    <option selected disabled :value="''">Select a mouza</option>
                                    <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id">{{ mouza.id }} : {{ mouza.desc }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_upazila_id">Upazila</label>
                                <select v-model="trainee.c_upazila_id" disabled id="c_upazila_id" name="c_upazila_id" class="custom-select custom-select-sm">
                                    <option selected disabled :value="''">Select a upazila</option>
                                    <option v-for="(upazilla, index) in upazillas" :key="index" :value="upazilla.id">{{ upazilla.id }} : {{ upazilla.desc }}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_district_id">District</label>
                                <select v-model="trainee.c_district_id" disabled id="c_district_id" name="c_district_id" class="custom-select custom-select-sm">
                                    <option selected disabled :value="''">Select a district</option>
                                    <option v-for="(district, index) in districts" :key="index" :value="district.id">{{ district.id }} : {{ district.desc }}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="nid">NID</label>
                                <input type="text" v-model="trainee.nid" disabled id="nid" name="nid" class="custom-select custom-select-sm" placeholder="Enter nid number"/>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="mobile_number">Mobile No. <span class="c-required">*</span></label>
                                <input type="number" v-model="trainee.mobile" v-validate="'required|length:11'" id="mobile_number" name="mobile_number" class="form-control form-control-sm" placeholder="Mobile number"/>
                                <div class="invalid-feedback">Please enter mobile number.</div>
                            </div>
                        </div>

                        <h5 class="mt-3">1. Household Information</h5>
                        <hr>
                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="name">1.1 Name of Household Head</label>
                                <input type="text" v-model="trainee.name" disabled id="name" name="name" class="custom-select custom-select-sm"/>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="village_id">1.2 Village</label>
                                <select v-model="trainee.c_village_id" disabled id="village_id" name="village_id" class="custom-select custom-select-sm">
                                    <option selected disabled :value="''">Select a village *</option>
                                    <option v-for="(village, index) in villages" :key="index" :value="village.id">{{ village.id }} : {{ village.desc }}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="father_husband_name">1.3 Father / Husband / Spouse Name</label>
                                <input type="text" v-model="trainee.father_husband_name" disabled id="father_husband_name" name="father_husband_name" class="custom-select custom-select-sm"/>
                            </div>
                        </div>

                        <h5 class="mt-3">2. Representative Information</h5>
                        <hr>
                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="rep_name">2.1 Name of Representative/Trainee</label>
                                <input type="text" v-model="trainee.rep_name ? trainee.rep_name : trainee.name" disabled id="rep_name" name="rep_name" class="custom-select custom-select-sm"/>
                            </div>

                            <div v-if="trainee.rep_address" class="col-md-6 col-sm-6 col-lg-3">
                                <label for="rep_address">2.2 Present Address <span class="c-required">*</span></label>
                                <textarea v-model="trainee.rep_address" id="rep_address" name="rep_address" rows="1" cols="33" class="form-control form-control-sm"></textarea>
                            </div>
                            <div v-else class="col-md-6 col-sm-6 col-lg-3">
                                <label for="rep_address">2.2 Present Address <span class="c-required">*</span></label>
                                <textarea v-model="trainee.address" id="rep_address" name="rep_address" rows="1" cols="33" class="form-control form-control-sm"></textarea>
                            </div>

                            <div v-if="trainee.rep_address"  class="col-md-6 col-sm-6 col-lg-3">
                                <label for="rep_permanent_address">2.3 Permanent Address</label>
                                <textarea v-model="trainee.rep_permanent_address" id="rep_permanent_address" name="rep_permanent_address" rows="1" cols="33" class="form-control form-control-sm"></textarea>
                            </div>
                            <div v-else class="col-md-6 col-sm-6 col-lg-3">
                                <label for="permanent_address">2.3 Permanent Address</label>
                                <textarea v-model="trainee.permanent_address" id="permanent_address" name="permanent_address" rows="1" cols="33" class="form-control form-control-sm"></textarea>
                            </div>

                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="c_rep_relation_id">2.4 Relation With HH</label>
                                <select v-model="trainee.c_rep_relation_id" disabled id="c_rep_relation_id" name="c_rep_relation_id" class="custom-select custom-select-sm">
                                    <option selected value="">Select Relation</option>
                                    <option v-for="(relation, index) in family_relations" :key="index" :value="relation.id">{{ relation.id }} : {{ relation.desc }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="rep_father_husband_name">2.5 Father / Husband / Spouse Name</label>
                                <input type="text" v-model="trainee.rep_father_husband_name ? trainee.rep_father_husband_name : trainee.father_husband_name " disabled id="rep_father_husband_name" name="rep_father_husband_name" class="custom-select custom-select-sm"/>
                            </div>
<!--                            <div class="col-md-6 col-sm-6 col-lg-3">-->
<!--                                <label for="mother_name">2.6 Mothers Name</label>-->
<!--                                <input type="text" v-model="trainee.rep_mother_name ? trainee.rep_mother_name : trainee.mother_name" disabled id="mother_name" name="mother_name" class="custom-select custom-select-sm"/>-->
<!--                            </div>-->

<!--                            <div v-if="trainee.rep_dob != null" class="col-md-6 col-sm-6 col-lg-3">-->
<!--                                <label for="rep_dob" >2.7 Birth Date</label>-->
<!--                                <input type="text" v-model="trainee.rep_dob" disabled id="rep_dob" name="rep_dob"  class="custom-select custom-select-sm" />-->
<!--                            </div>-->
<!--                            <div v-else class="col-md-6 col-sm-6 col-lg-3">-->
<!--                                <label for="dob" >2.7 Birth Date</label>-->
<!--                                <input type="text" v-model="trainee.dob" disabled id="dob" name="rep_dob"  class="custom-select custom-select-sm" />-->
<!--                            </div>-->

<!--                            <div v-if="trainee.c_rep_education_id != null" class="col-md-6 col-sm-6 col-lg-3">-->
<!--                                <label for="c_rep_education_id" >2.8 Education Qualification</label>-->
<!--                                <select v-model="trainee.c_rep_education_id" disabled id="c_rep_education_id" name="c_rep_education_id" class="custom-select custom-select-sm">-->
<!--                                    <option selected value="">Select Education</option>-->
<!--                                    <option v-for="(education, index) in educations" :key="index" :value="education.id">{{ education.id }} : {{ education.desc }}</option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                            <div v-else class="col-md-6 col-sm-6 col-lg-3">-->
<!--                                <label for="c_education_id" >2.8 Education Qualification</label>-->
<!--                                <select v-model="trainee.c_education_id" disabled id="c_education_id" name="c_education_id" class="custom-select custom-select-sm">-->
<!--                                    <option selected value="">Select Education</option>-->
<!--                                    <option v-for="(education, index) in educations" :key="index" :value="education.id">{{ education.id }} : {{ education.desc }}</option>-->
<!--                                </select>-->
<!--                            </div>-->
                            <div v-if="trainee.rep_mobile " class="col-md-6 col-sm-6 col-lg-3">
                                <label for="rep_mobile" >2.6 Mobile Number <span class="c-required">*</span></label>
                                <input type="number" v-model="trainee.rep_mobile" id="rep_mobile" name="rep_mobile"  class="form-control form-control-sm"  placeholder="Mobile Number"/>
                            </div>
                            <div v-else class="col-md-6 col-sm-6 col-lg-3">
                                <label for="rep_mobile" >2.6 Mobile Number <span class="c-required">*</span></label>
                                <input type="number" v-model="trainee.mobile" id="rep_mobile" name="rep_mobile"  class="form-control form-control-sm"  placeholder="Mobile Number"/>
                            </div>
                            <div v-if="trainee.rep_mobile" class="col-md-6 col-sm-6 col-lg-3">
                                <label for="rep_mobile_alt" >2.7 Mobile Number(Family)</label>
                                <input type="number" v-model="trainee.rep_mobile_alt" id="rep_mobile_alt" name="rep_mobile_alt"  class="form-control form-control-sm"  placeholder="Mobile Number"/>
                            </div>
                            <div v-else class="col-md-6 col-sm-6 col-lg-3">
                                <label for="mobile_alt" >2.7 Mobile Number(Family)</label>
                                <input type="number" v-model="trainee.mobile_alt" id="mobile_alt" name="mobile_alt"  class="form-control form-control-sm"  placeholder="Mobile Number"/>
                            </div>

                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="rep_nid">2.8 NID</label>
                                <input type="text" v-model="trainee.rep_nid ?  trainee.rep_nid : trainee.nid" disabled id="rep_nid" name="rep_nid" class="custom-select custom-select-sm"/>
                            </div>
                        </div>

                        <div class="form-row mt-2">
<!--                            <div v-if="trainee.c_rep_marital_status_id != null" class="col-md-6 col-sm-6 col-lg-3">-->
<!--                                <label for="c_rep_marital_status_id">2.9 Marital Status</label>-->
<!--                                <select v-model="trainee.c_rep_marital_status_id" disabled id="c_rep_marital_status_id" name="c_rep_marital_status_id" class="custom-select custom-select-sm">-->
<!--                                    <option selected value="">Select Relation</option>-->
<!--                                    <option v-for="(marital_status, index) in marital_statuses" :key="index" :value="marital_status.id">{{ marital_status.id }} : {{ marital_status.desc }}</option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                            <div v-else class="col-md-6 col-sm-6 col-lg-3">-->
<!--                                <label for="c_marital_status_id">2.9 Marital Status</label>-->
<!--                                <select v-model="trainee.c_marital_status_id" disabled id="c_marital_status_id" name="c_marital_status_id" class="custom-select custom-select-sm">-->
<!--                                    <option selected value="">Select Relation</option>-->
<!--                                    <option v-for="(marital_status, index) in marital_statuses" :key="index" :value="marital_status.id">{{ marital_status.id }} : {{ marital_status.desc }}</option>-->
<!--                                </select>-->
<!--                            </div>-->


                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="number_of_child">2.9.1 Number of Boy  <span class="c-required">*</span></label>
                                <input type="text" v-model="followup.number_of_boy"  v-validate="'required|numeric'"  id="number_of_child" name="number_of_child" class="form-control form-control-sm"/>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="number_of_child">2.9.2 Number of Daughter  <span class="c-required">*</span></label>
                                <input type="text" v-model="followup.number_of_daughter"  v-validate="'required|numeric'"  id="number_of_child" name="number_of_child" class="form-control form-control-sm"/>
                            </div>
                        </div>

                        <h5 class="mt-3">3. Occupation </h5>
                        <hr>
                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="past_occupation_id">3.1  Past Occupation <span class="c-required">*</span></label>
                                <select v-model="followup.past_occupation_id" v-validate="'required'" id="past_occupation_id" name="past_occupation_id" class="custom-select custom-select-sm">
                                    <option selected value="">Select Occupation</option>
                                    <option v-for="(occupation, index) in occupations" :key="index" :value="occupation.id">{{ occupation.id }} : {{ occupation.desc }}</option>
                                </select>
                                <div class="invalid-feedback">
                                    Please Select Valid Past Occupation
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="present_occupation_id">3.2  Present Occupation <span class="c-required">*</span></label>
                                <select v-model="followup.present_occupation_id" v-validate="'required'" id="present_occupation_id" name="present_occupation_id" class="custom-select custom-select-sm">
                                    <option selected value="">Select Occupation</option>
                                    <option v-for="(occupation, index) in occupations" :key="index" :value="occupation.id">{{ occupation.id }} : {{ occupation.desc }}</option>
                                </select>
                                <div class="invalid-feedback">
                                    Please Select Valid Present Occupation
                                </div>
                            </div>
                        </div>

                        <h5 class="mt-3">4. Income </h5>
                        <hr>
                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="family_monthly_income">4.1  Past Monthly Income <span class="c-required">*</span></label>
                                <input type="number" v-model="followup.current_family_monthly_expense" v-validate="'required|numeric'"  id="family_monthly_income" name="family_monthly_income" class="form-control form-control-sm"/>
                                <div class="invalid-feedback">Please Enter Past Monthly Income</div>
                            </div>
                          <div class="col-md-6 col-sm-6 col-lg-3">
                            <label for="income_from_training_trade">4.2a Income From Training Trade <span class="c-required">*</span></label>
                            <input type="number" v-model="followup.income_from_training_trade" v-validate="'required|numeric'"  id="income_from_training_trade" name="income_from_training_trade" class="form-control form-control-sm"/>
                            <div class="invalid-feedback">Please Income From Training Trade</div>
                          </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="past_monthly_income">4.2b Present Monthly Income <span class="c-required">*</span></label>
                                <input type="number" v-model="followup.present_monthly_income" v-validate="'required|numeric'"  id="past_monthly_income" name="past_monthly_income" class="form-control form-control-sm"/>
                                <div class="invalid-feedback">Please Enter Present Monthly Income</div>
                            </div>

                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="present_monthly_income">4.3  Family Monthly Income <span class="c-required">*</span></label>
                                <input type="number" v-model="followup.family_monthly_income" v-validate="'required|numeric'"  id="present_monthly_income" name="present_monthly_income" class="form-control form-control-sm"/>
                                <div class="invalid-feedback">Please Enter Family Monthly Income</div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="income_sources">Income Source <span class="c-required">*</span></label>
                                <multiselect v-model="followup.income_sources" :multiple="true" :clear-on-select="false" :preserve-search="true" label="desc" track-by="id" id="income_sources" :preselect-first="true" :options="income_sources" placeholder="Select Income Source"></multiselect>
                            </div>
                        </div>
                        <div class="form-row mt-2">
                            <b-button
                                    v-b-modal.income-source type="button" @click="$bvModal.show('income-source')"
                                    class="btn btn-success float-right btn-sm mb-1 text-black float-right">
                                Add Income Source
                                <i class="fas fa-plus"></i>
                            </b-button>
                        </div>
                        <div class="bg-white rounded box-shadow p-3">
                            <b-modal id="income-source" size="lg" title="Income Source Information" hide-footer>
                                <div class="modal-content bg-white rounded box-shadow">
                                    <div class="form-row">
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="desi_murgi" class="col-form-label col-form-label-sm">Desi Murgi</label>
                                            <input type="number" v-model="followup.desi_murgi" name="desi_murgi" id="desi_murgi" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="sonali_murgi" class="col-form-label col-form-label-sm">Sonali Murgi</label>
                                            <input type="number" v-model="followup.sonali_murgi" name="sonali_murgi" id="sonali_murgi" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="broiler" class="col-form-label col-form-label-sm">Broiler</label>
                                            <input type="number" v-model="followup.broiler" name="broiler" id="broiler" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="cockrell" class="col-form-label col-form-label-sm">Cockrell</label>
                                            <input type="number" v-model="followup.cockrell" name="cockrell" id="cockrell" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="tarki" class="col-form-label col-form-label-sm">Tarki</label>
                                            <input type="number" v-model="followup.tarki" name="tarki" id="tarki" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="hass" class="col-form-label col-form-label-sm">Hass</label>
                                            <input type="number" v-model="followup.hass" name="hass" id="hass" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="raj_hass" class="col-form-label col-form-label-sm">Raj Hass</label>
                                            <input type="number" v-model="followup.raj_hass" name="raj_hass" id="raj_hass" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="kabutor" class="col-form-label col-form-label-sm">Kabutor</label>
                                            <input type="number" v-model="followup.kabutor" name="kabutor" id="kabutor" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="goru" class="col-form-label col-form-label-sm">Goru</label>
                                            <input type="number" v-model="followup.goru" name="goru" id="goru" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="ghabi" class="col-form-label col-form-label-sm">Ghabi</label>
                                            <input type="number" v-model="followup.ghabi" name="ghabi" id="ghabi" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="chagol" class="col-form-label col-form-label-sm">Chagol</label>
                                            <input type="number" v-model="followup.chagol" name="chagol" id="chagol" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="bhera" class="col-form-label col-form-label-sm">Bhera</label>
                                            <input type="number" v-model="followup.bhera" name="bhera" id="bhera" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="buffalo" class="col-form-label col-form-label-sm">Buffalo</label>
                                            <input type="number" v-model="followup.buffalo" name="buffalo" id="buffalo" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="pukor" class="col-form-label col-form-label-sm">Pukor</label>
                                            <input type="number" v-model="followup.pukor" name="pukor" id="pukor" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="computer" class="col-form-label col-form-label-sm">Computer</label>
                                            <input type="number" v-model="followup.computer" name="computer" id="computer" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="sewing" class="col-form-label col-form-label-sm">Sewing</label>
                                            <input type="number" v-model="followup.sewing" name="sewing" id="sewing" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="welding" class="col-form-label col-form-label-sm">Welding</label>
                                            <input type="number" v-model="followup.welding" name="welding" id="welding" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="led" class="col-form-label col-form-label-sm">Led</label>
                                            <input type="number" v-model="followup.led" name="led" id="led" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="dukan" class="col-form-label col-form-label-sm">Dukan</label>
                                            <input type="number" v-model="followup.dukan" name="dukan" id="dukan" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-lg-4">
                                            <label for="others" class="col-form-label col-form-label-sm">Others</label>
                                            <input type="number" v-model="followup.others" name="others" id="others" v-validate="{ required: false, regex: /^[0-9]*$/ }" class="form-control form-control-sm" placeholder="Enter number"/>
                                            <div class="invalid-feedback">Value must be digit</div>
                                        </div>
                                    </div>
                                    <div class="form-row mt-2 mb-1">
                                        <div class="float-right">
                                            <b-button size="sm" variant="success" class="form-control-sm" @click="$bvModal.hide('income-source')">Ok</b-button>
                                        </div>
                                    </div>
                                </div>
                            </b-modal>
                        </div>

                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="training_trades">5. Training Trade <span class="c-required">*</span></label>
                                <multiselect v-model="followup.training_trades" :multiple="true" :clear-on-select="false" :preserve-search="true" label="desc" track-by="id" id="training_trades" :preselect-first="true" :options="training_trades" placeholder="Select training trade"></multiselect>
                            </div>
                        </div>
                        <h5 class="mt-3">6. Present Income Source </h5>
                        <hr>
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="is_job_holder">6.1 Are You Jobholder? <span class="c-required">*</span></label>
                                <select v-model="followup.is_job_holder" v-validate="'required'" id="is_job_holder" name="is_job_holder" class="form-control form-control-sm">
                                    <option selected value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                                <div class="invalid-feedback">Please enter yes/no</div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="job_description">Job Description</label>
                                <textarea v-model="followup.job_description" id="job_description" name="job_description" rows="1" cols="33" class="form-control form-control-sm"></textarea>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="doing_business">6.2 Any Business? <span class="c-required">*</span></label>
                                <select v-model="followup.doing_business" v-validate="'required'" id="doing_business" name="doing_business" class="form-control form-control-sm">
                                    <option selected value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                                <div class="invalid-feedback">Please enter yes/no</div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="business_types">6.3 Business Type <span v-if="followup.doing_business == 1" class="c-required">*</span></label>
                                <multiselect :disabled="followup.doing_business == 0" v-validate="followup.doing_business == 1 ? 'required' : '' " v-model="followup.business_types" :multiple="true" :clear-on-select="false" :preserve-search="true" label="desc" track-by="id" name="business_types" id="business_types" :options="business_types" placeholder="Select Business Type"></multiselect>
                                <div class="invalid-feedback" v-if="followup.doing_business == 1" >Select business type</div>
                            </div>
                        </div>
                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="money_sources">7. Business Money Source <span v-if="followup.doing_business == 1" class="c-required">*</span></label>
                                <multiselect :disabled="followup.doing_business == 0" v-validate="followup.doing_business == 1 ? 'required' : '' " v-model="followup.money_sources" :multiple="true" :clear-on-select="false" :preserve-search="true" label="desc" track-by="id" name="money_sources" id="money_sources" :options="money_sources" placeholder="Select Money Source"></multiselect>
                                <div class="invalid-feedback" v-if="followup.doing_business == 1">Select business money source</div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="businesses">8. What are you doing with the money you get from training?<span class="c-required">*</span></label>
                                <multiselect v-model="followup.businesses" :multiple="true" :clear-on-select="false" :preserve-search="true" label="desc" track-by="id" id="businesses" :preselect-first="true" :options="businesses" placeholder="Select Business Type"></multiselect>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="is_inspire">9. Someone else has seen inspired you<span class="c-required">*</span></label>
                                <input type="number" v-model="followup.is_inspire" v-validate="'required|numeric'"  id="is_inspire" name="is_inspire" class="form-control form-control-sm"/>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="govt_help">10. Are you receiving any service from the government office? <span class="c-required">*</span></label>
                                <select v-model="followup.govt_help" v-validate="'required'" id="govt_help" name="govt_help" class="form-control form-control-sm">
                                    <option selected value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
                                <div class="invalid-feedback">Select yes or no</div>
                            </div>
                        </div>
                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="govt_help_description">Govt Help Description</label>
                                <textarea v-model="followup.govt_help_description" id="govt_help_description" name="govt_help_description" rows="2" cols="33" class="form-control form-control-sm"></textarea>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="training_benefit">11. How have you benefited from the training? <span class="c-required">*</span></label>
                                <select v-model="followup.training_benefit" v-validate="'required'" id="training_benefit" name="training_benefit" class="form-control form-control-sm">
                                    <option selected value="0">Too much</option>
                                    <option value="1">More</option>
                                    <option value="2">Roughly</option>
                                    <option value="3">No</option>
                                </select>
                                <div class="invalid-feedback">Select any of them</div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="is_technology_use">12. Has there been any benefit to using advanced technology? <span class="c-required">*</span></label>
                                <select v-model="followup.is_technology_use" v-validate="'required'" id="is_technology_use" name="is_technology_use" class="form-control form-control-sm">
                                    <option selected value="0">Too much</option>
                                    <option value="1">More</option>
                                    <option value="2">Roughly</option>
                                    <option value="3">No</option>
                                </select>
                                <div class="invalid-feedback">Select any of them</div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="is_financially_improvement">13. How much have you benefited financially from training? <span class="c-required">*</span></label>
                                <select v-model="followup.is_financially_improvement" v-validate="'required'" id="is_financially_improvement" name="is_financially_improvement" class="form-control form-control-sm">
                                    <option selected value="0">Too much</option>
                                    <option value="1">More</option>
                                    <option value="2">Roughly</option>
                                    <option value="3">No</option>
                                </select>
                                <div class="invalid-feedback">Select any of them</div>
                            </div>
                        </div>
                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="is_society_respect">14. At present, your social status has increased? <span class="c-required">*</span></label>
                                <select v-model="followup.is_society_respect" v-validate="'required'" id="is_society_respect" name="is_society_respect" class="form-control form-control-sm">
                                    <option selected value="0">Too much</option>
                                    <option value="1">More</option>
                                    <option value="2">Roughly</option>
                                    <option value="3">No</option>
                                </select>
                                <div class="invalid-feedback">Select any of them</div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="survey_conducted_by">Survey Conducted By<span class="c-required">*</span></label>
                                <select v-model="followup.survey_conducted_by" v-validate="'required'" id="survey_conducted_by" name="survey_conducted_by" class="form-control form-control-sm">
                                    <option selected disabled :value="''">Select Worker who conduct Survey</option>
                                    <option v-for="(survey_worker, index) in survey_workers" :key="index" :value="survey_worker.id">{{ survey_worker.id }} :  {{ survey_worker.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="survey_conducted_date" class="col-form-label col-form-label-sm">Survey Date <span class="c-required">*</span></label>
                                <datepicker id="survey_conducted_date" v-model="followup.survey_conducted_date" :format="customSurveyConductedDate" name="survey_conducted_date" placeholder="Survey Date"></datepicker>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="survey_providers_by">Information Provided By<span class="c-required">*</span></label>
                                <input type="text" v-model="followup.survey_providers_by" v-validate="'required'"  id="survey_providers_by" name="survey_providers_by" class="form-control form-control-sm"/>
                            </div>
                        </div>
                        <div class="form-row mt-2">
                            <div class="col-md-6 col-sm-6 col-lg-3">
                                <label for="survey_providers_date" class="col-form-label col-form-label-sm">Information Provided Date <span class="c-required">*</span></label>
                                <datepicker id="survey_providers_date" v-model="followup.survey_providers_date" :format="customSurveyProviderDate" name="survey_providers_date" placeholder="Date"></datepicker>
                            </div>
                        </div>
                        <div class="form-row mt-2">
                            <div class="form-group col-md-6">
                                <button class="btn btn-success waves-effect waves-light mr-2" @click.prevent="update">Update</button>
                            </div>
                        </div>
                    </form>
                </b-card>
            </div>
        </div>

    </Layout>
</template>

<script>
    import moment from "moment";
    import Datepicker from "vuejs-datepicker";
    import Multiselect from "vue-multiselect";

    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Update Trainee Followup After",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, Datepicker, Multiselect},
        data() {
            return {
                title: "Update Trainee Followup After",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Trainee Followup",
                        active: true
                    }
                ],
                villages: [],
                mouzas: [],
                upazillas: [],
                districts: [],
                family_relations: [],
                occupations: [],
                training_trades: [],
                income_sources: [],
                business_types: [],
                money_sources: [],
                businesses: [],
                survey_workers: [],
                educations: [],
                marital_statuses: [],
                trainee: {
                    mobile: '',
                    mobile_alt: '',
                    rep_mobile: '',
                    rep_mobile_alt: '',
                    address: '',
                    permanent_address: '',
                    rep_address: '',
                    rep_permanent_address: '',
                },
                followup: {
                    form_no: '',
                    training_trades: [],
                    income_sources: [],
                    business_types: [],
                    money_sources: [],
                    businesses: [],
                    number_of_boy: '',
                    number_of_daughter: '',
                    past_occupation_id: '',
                    present_occupation_id: '',
                    present_monthly_income: '',
                    family_monthly_income: '',
                    current_family_monthly_expense: '',

                    desi_murgi: '',
                    sonali_murgi: '',
                    broiler: '',
                    cockrell: '',
                    tarki: '',
                    hass: '',
                    raj_hass: '',
                    kabutor: '',
                    goru: '',
                    ghabi: '',
                    chagol: '',
                    bhera: '',
                    buffalo: '',
                    pukor: '',
                    computer: '',
                    sewing: '',
                    welding: '',
                    led: '',
                    dukan: '',
                    others: '',

                    is_job_holder: '',
                    job_description: '',
                    doing_business: '',
                    is_inspire: '',
                    govt_help: '',
                    govt_help_description: '',
                    training_benefit: '',
                    is_technology_use: '',
                    is_financially_improvement: '',
                    is_society_respect: '',
                    survey_conducted_by: '',
                    survey_conducted_date: '',
                    survey_providers_by: '',
                    survey_providers_date: '',
                },
                followup_id: '',
                validation_errors: {},
                show: false,
            };
        },

        mounted() {
            this.followup_id = this.$route.params.followup_id;;
            this.getCodes();
            this.getFollowup();
        },
        methods: {
            customSurveyConductedDate(date) {
                this.followup.survey_conducted_date = moment(date).format("YYYY-MM-DD");
                return moment(date).format("YYYY-MM-DD");
            },
            customSurveyProviderDate(date) {
                this.followup.survey_providers_date = moment(date).format("YYYY-MM-DD");
                return moment(date).format("YYYY-MM-DD");
            },
            async update() {
                await this.$validator.validate().then(valid => {
                    if (valid) {
                        this.followup.mobile = this.trainee.mobile ? this.trainee.mobile : '';
                        this.followup.rep_mobile = this.trainee.rep_mobile ? this.trainee.rep_mobile : '';
                        this.followup.address = this.trainee.address ? this.trainee.address : '';
                        this.followup.rep_address = this.trainee.rep_address ? this.trainee.rep_address : '';
                        this.followup.rep_permanent_address = this.trainee.rep_permanent_address ? this.trainee.rep_permanent_address : '';
                        this.followup.permanent_address = this.trainee.permanent_address ? this.trainee.permanent_address : '';
                        this.followup.rep_mobile_alt = this.trainee.rep_mobile_alt ? this.trainee.rep_mobile_alt : '';
                        this.followup.mobile_alt = this.trainee.mobile_alt ? this.trainee.mobile_alt : '';


                        http.post("api/followup/update/" + this.followup.id,  this.followup)
                            .then(response => {
                                if (!response.data.error) {
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });

                                     this.$router.push("/trainee/followup/list/" + this.followup.trainee_id);

                                } else {
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Error",
                                        autoHideDelay: 5000,
                                        variant: "danger"
                                    });
                                }
                            })
                            .catch()
                    }
                });
            },
            async getCodes(){
                await http.get("api/followup/getCodes" )
                    .then(resource => {
                        this.villages = resource.data.villages;
                        this.mouzas = resource.data.mouzas;
                        this.upazillas = resource.data.upazillas;
                        this.districts = resource.data.districts;
                        this.family_relations = resource.data.family_relations;
                        this.occupations = resource.data.occupations;
                        this.training_trades = resource.data.training_trades;
                        this.business_types = resource.data.business_types;
                        this.income_sources = resource.data.income_sources;
                        this.money_sources = resource.data.money_sources;
                        this.businesses = resource.data.businesses;
                        this.survey_workers = resource.data.survey_workers;
                        this.educations = resource.data.educations;
                        this.marital_statuses = resource.data.marital_statuses;
                    })
            },
            async getFollowup(){
                await http.get("api/followup/edit/" + this.followup_id)
                .then(resource => {
                    this.followup = resource.data.followup
                    this.getTrainee(this.followup.trainee_id);
                })
            },
            async getTrainee(trainee_id){
                await http.get("api/followup/trainee/" + trainee_id)
                    .then(resource => {
                        this.trainee = resource.data.trainee
                    })
            },
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
    @import "vue-select/src/scss/vue-select.scss";

    .c-required {
        color: red;
    }

    .vdp-datepicker input {
        width: 100%;
        border-radius: 3px;
        border: 1px solid #ced4da;
        height: 30px;
        padding-left: 15px;
        color: #6b757d;
    }
</style>
